import { render, staticRenderFns } from "./SingleTripListing.vue?vue&type=template&id=1b7d5b06&scoped=true"
import script from "./SingleTripListing.vue?vue&type=script&lang=js"
export * from "./SingleTripListing.vue?vue&type=script&lang=js"
import style0 from "./SingleTripListing.vue?vue&type=style&index=0&id=1b7d5b06&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7d5b06",
  null
  
)

export default component.exports